/* eslint-disable import/prefer-default-export */
export var buttonCustomization = {
    MuiButton: {
        styleOverrides: {
            root: function (_a) {
                var theme = _a.theme;
                return ({
                //backgroundColor: theme.palette.primary.main, // Using theme color
                // '&:hover': {
                //   backgroundColor: '#1A4A80' // Using theme hover color
                // },
                });
            },
        },
    },
};
